/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OperatoreServizioMensaCreationForm { 
    email: string;
    nome?: string;
    cognome?: string;
    ruolo: OperatoreServizioMensaCreationFormRuoloEnum;
    servizi_ids?: Set<string>;
}
export enum OperatoreServizioMensaCreationFormRuoloEnum {
    OP_SCUOLA = 'OP_SCUOLA',
    OP_CENTRO_COTTURA = 'OP_CENTRO_COTTURA'
};



